import React from "react";
import Footer from "../../components/layout/footer";
import Header from "../../components/layout/header";
import FlashSale from "../Flash Sale/FlashSale";

const TermsOfUse = () => {
  return (
    <>
      <Header />
      <div className="privacy-policy">
        <h1>Terms of Use</h1>
        <div className="privacy-policy-content">
          <p>
            Welcome to ‘Kharutaai’! By accessing or using our website, you agree
            to comply with & be bound by the following Terms & Conditions.
            Please read these terms carefully before using our website. If you
            do not agree with these terms, you should not use our website
          </p>
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing & using our website, you agree to be bound by these
            Terms of Use & our Privacy Policy. We may update these terms from
            time to time, & it is your responsibility to review them
            periodically. Your continued use of the website constitutes
            acceptance of any changes.
          </p>
          <h2>2. Use of Website</h2>
          <p>
            You agree to use our website for lawful purposes only. You must not
            use our website:
          </p>
          <ul>
            <li>
              • In any way that violates applicable Local, National, or
              International Law.
            </li>
            <li>
              • To transmit or upload any material that is defamatory,
              offensive, or otherwise objectionable.
            </li>
            <li>
              • To interfere with or disrupt the operation of our website or
              servers.
            </li>
            <li>
              • To engage in any activity that could damage or disable the
              website.
            </li>
          </ul>
          <h2>3. Intellectual Property</h2>
          <p>
            All content on our website, including text, graphics, logos, &
            software, is the property of ‘Kharutaai LLP’ or its licensors and is
            protected by Intellectual Property laws. You may not use, reproduce,
            or distribute any content from our website without our prior written
            consent.
          </p>
          <h2>4. User Accounts</h2>
          <p>
            To access certain features of our website, you may be required to
            create an account. You are responsible for maintaining the
            confidentiality of your account information and for all activities
            that occur under your account. You agree to notify us immediately of
            any unauthorized use of your account.
          </p>
          <h2>5. Limitation of Liability</h2>
          <p>
            Kharutaai LLP is not liable for any indirect, incidental, special,
            or consequential damages arising from your use of our website or the
            inability to use our website. Our liability is limited to the
            fullest extent permitted by law.
          </p>
          <h2>6. Links to Other Websites</h2>
          <p>
            Our website may contain links to third-party websites that are not
            owned or controlled by Kharutaai LLP. We are not responsible for the
            content, privacy policies, or practices of any third-party websites.
            You access third-party websites at your own risk.
          </p>
          <h2>7. Termination</h2>
          <p>
            We reserve the right to terminate or suspend your access to our
            website at our sole discretion, without notice, for any reason,
            including if you breach these Terms of Use.
          </p>
          <h2>8. Governing Law</h2>
          <p>
            These Terms of Use are governed by & construed in accordance with
            the laws of the State of Maharashtra, without regard to its conflict
            of law principles. Any disputes arising under these terms will be
            resolved in the courts located in Thane, Maharashtra.
          </p>
          <h2>9. Contact Us</h2>
          <p>
            If you have any questions about these Terms of Use or any aspect of
            our website, please contact us at:
            <br />
            Email: Connect@Kharutaai.com
            <br />
            Phone: +919833368284
            <br />
            Address: Shop No. 05, Krishna Niwas, opp to TBZ Jewellers, near
            Chitale Express, BCabin Road, Thane west.
          </p>
          <p>
            Thank you for visiting Kharutaai (Formerly known as ‘Prathamesh
            Balache Kapade'). We appreciate your adherence to these Terms of
            Use.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsOfUse;
